$("#nav-icon").click(function () {
    if ($(this).hasClass("open")) {
        $(".menu-nav").slideUp(200, function() {
            $(".custom-nav-header").css('border-bottom-left-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom-right-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom', '1px solid #000000');
            $(".product__selectors").removeClass('product__selectors--background');
            $("#nav-background-overlay").removeClass('nav-background-overlay');
        });
        $(this).removeClass("open");
    } else {
        $(".custom-nav-header").css('border-bottom-left-radius', '0');
        $(".custom-nav-header").css('border-bottom-right-radius', '0');
        $(".custom-nav-header").css('border-bottom', 'none');
        $(".menu-nav").slideDown(200, function() {
            $("#nav-background-overlay").addClass('nav-background-overlay');
            $(".product__selectors").addClass('product__selectors--background');
        });
        $(this).addClass("open");
    }
});

$("#nav-background-overlay").click(function () {
    if ($("#nav-icon").hasClass("open")) {
        $(".menu-nav").slideUp(200, function() {
            $(".custom-nav-header").css('border-bottom-left-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom-right-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom', '1px solid #000000');
            $("#nav-background-overlay").removeClass('nav-background-overlay');
            $(".product__selectors").removeClass('product__selectors--background');
        });
        $("#nav-icon").removeClass("open");
    }
});

$(document).on('keydown', function(event) {
    if(event.key == 'Escape') {
        $(".menu-nav").slideUp(200, function() {
            $(".custom-nav-header").css('border-bottom-left-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom-right-radius', '13.44px');
            $(".custom-nav-header").css('border-bottom', '1px solid #000000');
            $("#nav-background-overlay").removeClass('nav-background-overlay');
            $(".product__selectors").removeClass('product__selectors--background');
        });
        $("#nav-icon").removeClass("open");
    }
})